module.exports = __webpack_public_path__ + "static/max-planck-institute-c308ecc31b075da067cf95da52e29582.png";